/**
 * When a product is split into several color tiles (see
 * snippets/product-block-by-color.liquid), those tiles all share the same
 * data-product-id and would otherwise render back-to-back, making the grid
 * look like a repeated list of one product. This spreads them out among the
 * grid's other distinct products with a round-robin interleave, wherever
 * that's actually possible (a grid made up of a single product's colors is
 * left as-is — there's nothing to mix it with).
 *
 * Runs on load and again after any AJAX-driven grid update (filtering,
 * sorting, recommendations, pagination, etc.) via a MutationObserver, since
 * this theme's ajax swaps don't dispatch a dedicated "content updated" event
 * to hook into directly.
 */
(function () {
  function interleaveGrid(grid) {
    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.hasAttribute('data-product-id');
    });
    if (items.length < 2) return;

    var groups = [];
    var groupIndexByKey = {};
    items.forEach(function (el) {
      var key = el.getAttribute('data-product-id');
      if (!(key in groupIndexByKey)) {
        groupIndexByKey[key] = groups.length;
        groups.push([]);
      }
      groups[groupIndexByKey[key]].push(el);
    });

    // Only one distinct product in this grid (e.g. a collection that's
    // entirely one style's colors) — nothing to interleave it with.
    if (groups.length < 2) return;

    // Weighted/deficit scheduling: spread each group evenly across the whole
    // sequence in proportion to its size, rather than plain round-robin (which
    // would exhaust small groups first and dump the rest of a large group,
    // e.g. one product with many colors, all together at the end).
    var total = items.length;
    var shares = groups.map(function (group) {
      return group.length / total;
    });
    var placed = groups.map(function () {
      return 0;
    });
    var ordered = [];
    for (var pos = 0; pos < total; pos += 1) {
      var best = -1;
      var bestScore = -Infinity;
      for (var g = 0; g < groups.length; g += 1) {
        if (placed[g] >= groups[g].length) continue;
        var score = shares[g] * (pos + 1) - placed[g];
        if (score > bestScore) {
          bestScore = score;
          best = g;
        }
      }
      ordered.push(groups[best][placed[best]]);
      placed[best] += 1;
    }

    ordered.forEach(function (el) {
      grid.appendChild(el);
    });
  }

  function interleaveAllGrids() {
    var grids = document.querySelectorAll('.product-grid');
    if (!grids.length) return;
    // Disconnect first so our own reordering doesn't trigger the observer again.
    observer.disconnect();
    grids.forEach(interleaveGrid);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  var observer = new MutationObserver(interleaveAllGrids);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interleaveAllGrids);
  } else {
    interleaveAllGrids();
  }

  observer.observe(document.body, { childList: true, subtree: true });
})();
